import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import App from './App'
import { initSentry } from './lib/sentry'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

initSentry()

const rootElement = document.getElementById('root')

if (rootElement) {
  // eslint-disable-next-line
  ReactDOM.render(
    <Sentry.ErrorBoundary
      fallback={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            gap: '16px',
          }}
        >
          <p>Une erreur est survenue.</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ padding: '10px 20px', cursor: 'pointer' }}
          >
            Recharger la page
          </button>
        </div>
      }
      showDialog
    >
      <App />
    </Sentry.ErrorBoundary>,
    rootElement
  )
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.register()
